// Publishes the always-visible app shell into the UI-context store: the viewport (mobile/desktop),
// the sidebar nav labels the user can see (role-aware), whether the sidebar is collapsed behind the
// mobile menu button, and the signed-in user. This is the "chrome" SAM sees on every page.
import { useEffect, useState } from 'react';
import { useAppDispatch } from '@/hooks/useAppDispatch';
import { useAppSelector } from '@/hooks/useAppSelector';
import { setUIContext } from '@/redux/slices/uiContextSlice';
import { getNavItems } from '@/components/Layout/navItems';

export function useShellUIContext(): void {
  const dispatch = useAppDispatch();
  const roles = useAppSelector((s) => s.sessionState.roles);
  const userName = useAppSelector((s) => s.sessionState.userName);
  const userEmail = useAppSelector((s) => s.sessionState.userEmail);

  // Track the lg breakpoint (matches DashboardLayout / Sidebar drawer behavior).
  const [isDesktop, setIsDesktop] = useState(
    () => typeof window !== 'undefined' && window.matchMedia('(min-width: 1024px)').matches,
  );
  useEffect(() => {
    const mq = window.matchMedia('(min-width: 1024px)');
    const onChange = () => setIsDesktop(mq.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);

  const isPlatformRole = roles.includes('platform_admin') || roles.includes('platform_support');
  useEffect(() => {
    dispatch(setUIContext({
      viewport: isDesktop ? 'desktop' : 'mobile',
      chrome: {
        nav: getNavItems(isPlatformRole).map((i) => i.label),
        navCollapsed: !isDesktop,
        user: { name: userName, email: userEmail },
      },
    }));
  }, [dispatch, isDesktop, isPlatformRole, userName, userEmail]);
}
